import React from 'react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@rocco/components/tooltip';

/**
 * Tooltip shown on conversation mutation controls when the viewer is not a participant.
 */
export const NON_PARTICIPANT_ACTION_TOOLTIP =
    "You're not a participant in this conversation";

/**
 * Tooltip for a button or action that is not available to non-participants.
 */
export function NonParticipantTooltip({
    children,
    asChild,
    side = 'top',
}: {
    children: React.ReactNode;
    asChild?: boolean;
    side?: React.ComponentProps<typeof TooltipContent>['side'];
}) {
    return (
        <TooltipProvider delayDuration={0}>
            <Tooltip>
                <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
                <TooltipContent side={side}>
                    {NON_PARTICIPANT_ACTION_TOOLTIP}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
